<script setup lang="ts">
// 區間單選 chip 群組:人數(最低需求)、價格(預算上限) 共用。
// 取代原本的 el-select 下拉,改為一目了然的 chip 按鈕。
interface ChipOption {
  id: number
  name: string
}

const props = defineProps<{
  title: string
  options: ChipOption[]
  modelValue: number
  // 選到非「不限」(id !== 0) 時顯示的提示文字
  helperText?: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: number]
}>()

function selectChip(id: number): void {
  // 再次點選已選的 chip → 取消(回到不限 0)
  emit('update:modelValue', props.modelValue === id ? 0 : id)
}

const showHelper = computed(() => Boolean(props.helperText) && props.modelValue !== 0)
</script>

<template>
  <div class="chip-group">
    <div class="chip-group-title">
      <slot name="icon"></slot>
      <span>{{ title }}</span>
    </div>
    <ul class="chip-group-list">
      <li v-for="item in options"
          :key="item.id"
          class="chip-item"
          :class="{ 'chip-item-active': modelValue === item.id }"
          @click="selectChip(item.id)">
        {{ item.name }}
      </li>
    </ul>
    <p v-if="showHelper"
       class="chip-group-helper">↳ {{ helperText }}</p>
  </div>
</template>

<style scoped lang="scss">
.chip-group {
  .chip-group-title {
    @apply mb-[8px] flex items-center gap-[5px] text-[14px] font-semibold text-osn-dark-grey-00;
  }

  .chip-group-list {
    @apply grid grid-cols-3 gap-[6px];

    .chip-item {
      @apply px-[4px] h-[34px] flex items-center justify-center text-center text-[13px] whitespace-nowrap
      text-osn-dark-grey-00 rounded-[8px] border border-osn-grey-03 cursor-pointer
      hover:border-osn-yellow-00;

      &-active {
        @apply bg-osn-yellow-00 border-osn-yellow-00 font-semibold;
      }
    }
  }

  .chip-group-helper {
    @apply mt-[8px] text-[12px] text-osn-grey-01;
  }
}
</style>
